<template>
  <div class="FormRelatedArticle">
    <RowGrid :columns="4">
      <Field
        :value="item.title"
        @update:value="$up('item.title', $event)" />
      <Field
        :value="item.url"
        @update:value="$up('item.url', $event)" />
      <Field
        type="number"
        :value="item.articleId"
        @update:value="$up('item.articleId', $event)" />
      <Field
        type="number"
        :value="item.siteId"
        @update:value="$up('item.siteId', $event)" />
      <Btn class="danger sm ib inv noBorder" @click="$emit('remove')">
        <Icon name="cross" />
      </Btn>
    </RowGrid>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
  },
}
</script>

<style lang="scss">
.FormRelatedArticle {
  border-bottom: 1px solid $border-color;
  margin-bottom: $grid-unit-half;

  .Field-cont {
    margin: 0;
  }
}
</style>
